import { FormatIcu } from '@tolgee/format-icu';
import { DevTools, Tolgee } from '@tolgee/web';

export const LOCALES = [
  { value: 'en', label: 'English', countryCode: 'GB' },
  { value: 'zh', label: '中文简体', countryCode: 'CN' },
];

export const ALL_LANGUAGES = ['en', 'zh'];

export const DEFAULT_LANGUAGE = 'en';

export function TolgeeBase() {
  return Tolgee()
    .use(DevTools())
    .use(FormatIcu())
    .updateDefaults({
      fallbackLanguage: 'en',
      observerOptions: {
        fullKeyEncode: false,
      },
      staticData: {
        en: () => import('../../message/en.json').then((module) => module.default),
        zh: () => import('../../message/zh.json').then((module) => module.default),
      },
    });
}

export const tolgee = (language: string) =>
  TolgeeBase().init({
    defaultLanguage: 'en',
    language,
  });
